'use client'

import NextErrorPage from '#/src/components/NextErrorPage'

export default NextErrorPage
